(function () {
'use strict';

angular
    .module('surveyCampaignControllers')
    .directive('campaignQuestionCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            question: '=',
            componentIdx: '=',
            readOnly: '=',
            isOrdering: '=',
            isLast: '=',
            layoutRatio: '=?',
            moveUp: '&',
            moveDown: '&',
            toDuplicateQuestion: '&',
            toRemoveQuestion: '&',
            toUpdateQuestion: '&',
            toAddQuestionChoice: '&',
            toRemoveQuestionChoice: '&',
            toUpdateQuestionChoice: '&',
        },
        restrict: 'AE',
        templateUrl: require('./campaignQuestionCard.tpl.html'),
        controller: ['$scope', function ($scope) {
            $scope.getQuestionTemplateUrl = function () {
                return '/app/Main/survey/campaign/campaignQuestion-' +
                        $scope.question.QuestionTypeCategoryCode + '-' +
                        $scope.question.QuestionTypeCategoryBehaviour + '.tpl.html';
            }

            // Is Multiple Choice
            $scope.isCustomMultipleChoiceQuestion = function () {
                return $scope.question.QuestionTypeCode === 'CustomMultipleChoice' ||
                       $scope.question.QuestionTypeCategoryBehaviour === 'QuizWithOneResponse';
            };

            // Can edit Title
            $scope.canEditTitle = function () {
                return $scope.question.QuestionTypeCategoryID !== 6;
            };

            // Can choose a right answer
            $scope.canChooseRightAnswer = function () {
                return $scope.question.QuestionTypeCategoryBehaviour === 'QuizWithOneResponse';
            };

            // Can edit postmortem
            $scope.canEditPostmortem = function () {
                return $scope.question.QuestionTypeCategoryBehaviour === 'QuizWithOneResponse';
            };

            // Show/Hide Actions
            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly || $scope.isOrdering) return;
                $scope.view.displayActions = !$scope.view.displayActions;
                $scope.stopEditingCard($event);
                $event.stopPropagation();
            };

            // Edit Card
            $scope.editCard = function (question, $event) {
                if ($scope.readOnly) return;
                $scope.view.displayActions = false;
                $scope.view.isEditingCard = true;
                $event.stopPropagation();
            };

            // Stop editing Card
            $scope.stopEditingCard = function ($event) {
                $scope.view.isEditingCard = false;
                $event.stopPropagation();
            };

            // Add Question Choice
            $scope.addQuestionChoice = function (choice) {
                $scope
                    .toAddQuestionChoice()($scope.question, choice)
                    .then(function (newChoice) {
                        if (_.isUndefined($scope.question.QuestionChoices)) {
                            $scope.question.QuestionChoices = [];
                        }
                        $scope.question.QuestionChoices.push(newChoice);
                        $scope.choiceToAdd = {};
                    });
            };

            // Remove Question Choice
            $scope.removeQuestionChoice = function (choice) {
                $scope
                    .toRemoveQuestionChoice()($scope.question, choice)
                    .then(function () {
                        $scope.question.QuestionChoices = _.reject($scope.question.QuestionChoices, { QuestionChoiceID: choice.QuestionChoiceID });
                    });
            };

            // Update Question Choice
            $scope.updateQuestionChoice = function (choice, newTitle) {
                var choiceToUpdate = _.clone(choice);
                choiceToUpdate.TitleEN = newTitle;

                return $scope.toUpdateQuestionChoice()($scope.question, choiceToUpdate);
            };


            // Set Right answer
            $scope.setRightAnswer = function (choice) {

                var toRemoveRightAnswer = _.find($scope.question.QuestionChoices, { IsRightAnswer: true });
                if (!_.isUndefined(toRemoveRightAnswer)) {
                    toRemoveRightAnswer.IsRightAnswer = false;
                    $scope.toUpdateQuestionChoice()($scope.question, toRemoveRightAnswer);
                }

                choice.IsRightAnswer = true;
                $scope.toUpdateQuestionChoice()($scope.question, choice);
            }

            // Duplicate Question Choice
            $scope.duplicateQuestion = function ($event) {
                $scope.toDuplicateQuestion();
                $event.stopPropagation();
            };

            // Remove Question
            $scope.removeQuestion = function ($event) {
                $scope.toRemoveQuestion();
                $event.stopPropagation();
            };

            // Update Question Number
            $scope.updateQuestionNumber = function (newNumber) {
                var questionToUpdate = _.clone($scope.question);
                questionToUpdate.OrderNumber = newNumber;

                return $scope.toUpdateQuestion()(questionToUpdate);
            };

            // Update Question Title
            $scope.updateQuestionTitle = function (newTitle) {
                var questionToUpdate = _.clone($scope.question);
                questionToUpdate.TitleEN = newTitle;

                return $scope.toUpdateQuestion()(questionToUpdate);
            };

            // Update Question Subtitle
            $scope.updateQuestionSubtitle = function (newSubtitle) {
                var questionToUpdate = _.clone($scope.question);
                questionToUpdate.SubTitleEN = newSubtitle;

                return $scope.toUpdateQuestion()(questionToUpdate);
            };
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };

            // Display or not actions
            scope.view                = {};
            scope.view.displayActions = false;
            scope.view.isEditingCard  = false;

            scope.choiceToAdd = {};
        }
    };
}
})();
